import { useIntl } from "react-intl";

import { SubmitButton } from "../common/submit-button";

export const NewUserSubmitButton = ({
    hasPrivacyPolicy = false
}: {
    hasPrivacyPolicy?: boolean;
}) => {
    const { formatMessage } = useIntl();

    const submitMessage = hasPrivacyPolicy
        ? formatMessage({
              id: "siteActivation.nameSite.agreeButton",
              defaultMessage: "Agree and start now"
          })
        : formatMessage({
              id: "siteActivation.nameSiteNewUser.continueButton",
              defaultMessage: "Continue"
          });

    return <SubmitButton submitMessage={submitMessage} />;
};
